import { defineComponent as _defineComponent } from 'vue'
import { isWxShareInited } from '@/hooks/use-wx-share';
import { i18n } from '@/i18n';
import { language } from '@tencent/ppd-base-libs';
import { ImageLoader } from '@tencent/wphk-components-content-loader';
import { useStorage } from '@vueuse/core';
import { useShowShare } from '../../common-share-module/hooks/use-show-share';

export default /*#__PURE__*/_defineComponent({
  __name: 'share-icon',
  setup(__props) {

const { showShare } = useShowShare();
const shouldShowTip = useStorage(`[${process.env.VUE_APP_PKGNAME}]share-tips`, true);
const onClickShare = () => {
  shouldShowTip.value = false;
  showShare();
};
const isEn = language.isEn();

return { __sfc: true,showShare, shouldShowTip, onClickShare, isEn, isWxShareInited, i18n, ImageLoader }
}

})